import { render, staticRenderFns } from "./default.vue?vue&type=template&id=5b0e2abc&"
var script = {}
import style0 from "./default.vue?vue&type=style&index=0&id=5b0e2abc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheHeader: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/TheHeader.vue').default,TheFooter: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/TheFooter.vue').default,JrDesigner: require('/Users/jerei/Documents/宇浩/工作/nuxt2-demo/components/jr/designer/JrDesigner.vue').default})
